module.exports = __webpack_public_path__ + "assets/img/bg@2x.4b7a09de.png";